export default {
  "section1":{
    "questions": {
      "question1": {
        "label": "1. Quel type de site internet avez-vous ?",
        "options": [
          {
            "name": "vitrine3",
            "value": "Site vitrine présentant l'activité de mon entreprise"
          },
          {
            "name": "marchant3",
            "value": "Site marchand de vente en ligne"
          },
          {
            "name": "reservation3",
            "value": "Site de réservation en ligne"
          },
          {
            "name": "click&collect3",
            "value": "Site de click & collect"
          }
        ]
      },
    }
  },
  "section2": {
    "image": "/Step1.png",
    "questions": {
      "question2": {
        "label": "2. Avez-vous déjà utilisé la publicité payante pour faire la promotion de votre entreprise ou produits ?"
      },
      "question3": {
        "label": "3. Vendez-vous vos produits et services sur d'autres plateformes que les vôtres ? (Treatwell, Amazon, La fourchette...)"
      },
      "question4": {
        "label": "4. Avez-vous un établissement physique ?",
        "answers": [
          "Oui, un unique établissement",
          "Oui, j'en ai plusieurs",
          "Non"
        ]
      },
      "question5": {
        "label": "5. Quel est le code postal de votre entreprise ?"
      },
      "question6": {
        "label": "6. Vos clients sont :",
        "answers": [
          "Des particuliers",
          "Des professionnels",
          "Les 2"
        ]
      }
    }
  },
  "section3": {
    "image": "/Step2.png",
    "questions": {
      "question7": {
        "label": "7. Avez-vous actuellement des projets en cours de réalisation (par exemple travaux de rénovation, projet d'agrandissement, achat de matériel, création de site internet, recrutement de nouveaux collaborateurs etc..)",
        "answers": [
          "Non, je n'ai aucun projet en cours et je ne prévois pas d'en lancer dans les 12 prochains mois",
          "Non, je n'ai pas de projets en cours mais je prévois d'en lancer dans les 12 prochains mois",
          "Oui, j'ai un projet en cours de réalisation",
          "Oui, j'ai plusieurs projets en cours de réalisation"
        ]
      },
      "question8": {
        "label": "8. En pensant à votre activité professionnelle actuelle, comment projetez-vous dans les 3 prochaines années ?",
        "answers": [
          "Je souhaite développer mon activité avec des changements majeurs",
          "Je souhaite poursuivre le développement de mon activité actuelle",
          "Je souhaite garder mon niveau d'activité actuel",
          "Je souhaite plutôt réduire mon activité",
          "J’envisage de changer d'activité ou de me retirer complètement (retraite, reconversion, etc.)",
          "Je ne sais pas"
        ]
      },
      "question9": {
        "label": "9. Imaginez que vous souhaitez intégrer un nouvel outil numérique au sein de votre entreprise. Indiquez à quel point chacune de ces tâches ci-dessous vous semble facile ou difficile pour vous personnellement",
        "answers": [
              "Très facile",
              "Plutôt facile",
              "Ni facile / Ni difficile",
              "Plutôt difficile",
              "Très difficile"
        ],
        "optionsLabel": [
          "Evaluer si cet outil est utile pour mon entreprise",
          "Choisir l'outil à mettre en place",
          "Apprendre à me servir de l'outil",
          "Financer ce projet",
          "Trouver le professionnel ou l'entreprise pour installer l'outil",
          "Trouver le temps de me servir de l'outil moi-même une fois mis en place"
        ]
      }
    }
  },
  "section4": {
    "image": "/Step3.png",
    "questions": {
      "question10": {
        "label": "10. Avez-vous un expert chargé du développement et de la mise à jour de votre site internet :",
        "answers": [
              "Oui, en interne",
              "Oui, en externe",
              "Non, mais on s'en occupe en interne",
              "Non, personne ne s'en occupe"
        ]
      },
      "question11": {
        "label": "11. Quelles sont aujourd'hui vos attentes business concernant votre site internet ?",
        "answers": [
          "J'ai de fortes attentes",
          "Je souhaite qu'il contribue en partie au développement de mon business ",
          "Je n'ai pas d'attente particulière",
          "Je ne sais pas"
        ]
      },
      "question12": {
        "label": "12. Avez-vous une stratégie de rédaction de contenu et d'amélioration technique de votre site  vous permettant d'optimiser votre positionnement sur les pages de recherche Google ? (Référencement naturel)",
        "answers": [
          "Oui, un expert du sujet s'en occupe en interne",
          "Oui, un expert du sujet s'en occupe en externe",
          "Oui, on s'en occupe en interne mais sans expertise précise",
          "Non, personne ne s'en occupe"
        ]
      },
      "question13": {
        "label": "13. Quelles sont aujourd'hui vos attentes concernant votre stratégie de référencement naturel ?",
        "answers": [
          "J'ai de fortes attentes",
          "Je souhaite maintenir ma visibilité comme actuellement",
          "Je n'ai pas d'attente particulière ",
          "Je ne sais pas"
        ]
      },
      "question14": {
        "label": "14. Quels sont les moyens de communication direct que vous utilisez pour parler de votre actualité à vos clients ?",
        "options": [
          {
            "name": "calltel10",
            "value": "Appel téléphonique"
          },
          {
            "name": "courrier10",
            "value": "Courrier"
          },
          {
            "name": "sms10",
            "value": "SMS"
          },
          {
            "name": "email10",
            "value": "Email"
          },
          {
            "name": "whatsapp10",
            "value": "WhatsApp"
          },
          {
            "name": "messenger10",
            "value": "Messenger"
          },
          {
            "name": "chatbot10",
            "value": "Chat Bot"
          },
          {
            "name": "aucun10",
            "value": "Aucun"
          }
        ]
      },
      "question15": {
        "label": "15. Avez-vous un expert chargé de votre communication direct ?",
        "answers": [
          "Oui, en interne",
          "Oui, en externe",
          "Non, on s'en occupe en interne sans expertise précise",
          "Non, personne ne s'en occupe"
        ]
      },
      "question16": {
        "label": "16. Quelles sont aujourd'hui vos attentes concernant votre stratégie de communication direct ?",
        "answers": [
          "J'ai de fortes attentes",
          "Je souhaite maintenir ma visibilité comme actuellement",
          "Je n'ai pas d'attente particulière ",
          "Je ne sais pas"
        ]
      },
      "question17": {
        "label": "17. Sur quel(s) réseau(x) social(aux) êtes vous présent(s) ?",
        "options": [
          {
            "name": "facebook9",
            "value": "Page facebook"
          },
          {
            "name": "instagram9",
            "value": "Compte Instagram"
          },
          {
            "name": "linkedin9",
            "value": "Compte Linkedin"
          },
          {
            "name": "rs9",
            "value": "D'autres pages sur les réseaux sociaux"
          },
          {
            "name": "GMB9",
            "value": "Page Google My Business"
          },
          {
            "name": "other9",
            "value": ""
          }
        ]
      },
      "question18": {
        "label": "18. Avez-vous un expert chargé de l'animation de vos réseaux sociaux ?",
        "answers": [
          "Oui, en interne",
          "Oui, en externe",
          "Non, on s'en occupe en interne sans expertise précise",
          "Non, personne ne s'en occupe"
        ]
      },
      "question19": {
        "label": "19. Quelles sont aujourd'hui vos attentes concernant votre communication sur les réseaux sociaux ?",
        "answers": [
          "J'ai de fortes attentes",
          "Je souhaite maintenir ma visibilité comme actuellement",
          "Je n'ai pas d'attente particulière ",
          "Je ne sais pas"
        ]
      }
    }
  },
}